import useSWR, { type SWRResponse } from "swr";
import type { CountryType, Nullable } from "../../../@types/generic";
import { useCountry } from "../../../hooks/useCountry";
import { QUERY_NAME_NCAST_NEARBY } from "../../cacheKeys";
import { fetcher } from "../index";
import type { NCastNearby } from "../types/nCastNearby";

export const fetchNCastNearby = async (
    latitude: number,
    longitude: number,
    country: CountryType
): Promise<Nullable<NCastNearby>> =>
    fetcher<NCastNearby>(
        {
            path: `/weather/ncast/${latitude.toString()}/${longitude.toString()}`,
        },
        { country }
    )
        .then(({ data }) => data)
        .catch(() => null);

type Parameters = {
    latitude: Nullable<number> | undefined;
    longitude: Nullable<number> | undefined;
    enabled?: boolean;
};

export const useNCastNearby = ({
    latitude,
    longitude,
    enabled,
}: Parameters): SWRResponse<Nullable<NCastNearby>> => {
    const country = useCountry();
    const isEnabled =
        ((typeof enabled === "boolean" && enabled) ||
            typeof enabled === "undefined") &&
        typeof latitude === "number" &&
        typeof longitude === "number";

    const { data, isLoading, ...rest } = useSWR<Nullable<NCastNearby>>(
        isEnabled
            ? [QUERY_NAME_NCAST_NEARBY, latitude, longitude, country]
            : null,
        () => fetchNCastNearby(latitude as number, longitude as number, country)
    );

    return {
        data,
        isLoading: isLoading || data === undefined,
        ...rest,
    };
};
